import { render, staticRenderFns } from "./app_sc.vue?vue&type=template&id=3a5c2acc&scoped=true&"
import script from "./app_sc.vue?vue&type=script&lang=js&"
export * from "./app_sc.vue?vue&type=script&lang=js&"
import style0 from "./app_sc.vue?vue&type=style&index=0&id=3a5c2acc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c2acc",
  null
  
)

export default component.exports